<mat-spinner *ngIf="!isLoaded"></mat-spinner>

<div *ngIf="isLoaded">
    <div class="row">
        <!-- Yksikön kuvausteksti-->
        <div *ngIf="organisation?.description?.valueFi || organisation?.description?.valueSv">
            <mat-card class="card-panel light-blue lighten-5 z-depth-2">
                <app-markdown [body]="globals.getLocalizedValueForTitle(organisation?.description)"></app-markdown>
            </mat-card>
        </div>
    </div>
</div>
